// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__hRUZg","loader":"Loader_loader__rJDrh","spin":"Loader_spin__7tjIP"};